import { API_ROUTES } from 'App';
import { AxiosError, HttpStatusCode, isAxiosError } from 'axios';
import { path } from 'ramda';

const { REACT_APP_URL } = process.env;

export const getErrorStatusCode = (error: unknown) => path(['response', 'status'], error);
export const isUnauthorizedError = (error: AxiosError) =>
  getErrorStatusCode(error) === HttpStatusCode.Unauthorized;
export const isAccessDenied = (error: unknown) => {
  return getErrorStatusCode(error) === HttpStatusCode.Forbidden;
};
export const isBadRequest = (error: unknown) => {
  if (getErrorStatusCode(error) === HttpStatusCode.BadRequest) {
    // exception for login & verification requests
    const isLoginRequest =
      isAxiosError(error) && error.request.responseURL === REACT_APP_URL + API_ROUTES.login();
    const isVerificationRequest =
      isAxiosError(error) &&
      error.request.responseURL === REACT_APP_URL + API_ROUTES.verification();
    if (isLoginRequest || isVerificationRequest) {
      return false;
    }
  }
  return getErrorStatusCode(error) === HttpStatusCode.BadRequest;
};
